import { render, staticRenderFns } from "./MobilityDetails.vue?vue&type=template&id=05de86d8"
import script from "./MobilityDetails.vue?vue&type=script&lang=js"
export * from "./MobilityDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports